var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSettings(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "settings_main",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_208",
    "data-name": "Rectangle 208",
    width: 34,
    height: 34,
    transform: "translate(767 790)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 25.853,
    height: 25.859,
    fill: "#707070"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_22",
    "data-name": "Mask Group 22",
    transform: "translate(-767 -790)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(771 794)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M14.22,25.859H11.635c-.066-.022-.13-.05-.2-.066a2.512,2.512,0,0,1-1.956-2.456.838.838,0,0,0-1.473-.624,2.515,2.515,0,0,1-3.621-.04c-.41-.4-.817-.808-1.217-1.22a3,3,0,0,1-.386-.481,2.507,2.507,0,0,1,.328-3.1.9.9,0,0,0,.317-.814.827.827,0,0,0-.872-.68A2.528,2.528,0,0,1,0,13.784c0-.584,0-1.167,0-1.751A2.519,2.519,0,0,1,2.522,9.488a.838.838,0,0,0,.619-1.474,2.516,2.516,0,0,1,.045-3.621c.4-.4.8-.8,1.2-1.2a3.19,3.19,0,0,1,.5-.405,2.514,2.514,0,0,1,3.138.364.8.8,0,0,0,1.3-.074A1.22,1.22,0,0,0,9.475,2.5,2.54,2.54,0,0,1,12,.005c.6-.008,1.2,0,1.8,0a2.519,2.519,0,0,1,2.565,2.527.838.838,0,0,0,1.478.614,2.516,2.516,0,0,1,3.621.047c.4.4.8.795,1.2,1.2a3.133,3.133,0,0,1,.4.5,2.512,2.512,0,0,1-.351,3.119.855.855,0,0,0-.289.821.829.829,0,0,0,.9.65A2.529,2.529,0,0,1,25.8,11.494a1.114,1.114,0,0,0,.054.145v2.585c-.044.143-.085.287-.133.429A2.535,2.535,0,0,1,23.3,16.379a.823.823,0,0,0-.876.674.887.887,0,0,0,.306.817,2.508,2.508,0,0,1,.044,3.482c-.463.5-.954.974-1.447,1.446a2.347,2.347,0,0,1-1.418.643,2.542,2.542,0,0,1-2.1-.749.821.821,0,0,0-1.412.377,1.684,1.684,0,0,0-.022.321,2.538,2.538,0,0,1-1.749,2.347c-.134.044-.269.082-.4.123M6.2,4.069a3.193,3.193,0,0,0-.581.342c-.391.356-.754.743-1.128,1.118A.842.842,0,0,0,4.459,6.9a2.509,2.509,0,0,1,.7,1.727,2.546,2.546,0,0,1-2.551,2.578.814.814,0,0,0-.886.888c0,.574,0,1.149,0,1.723a.814.814,0,0,0,.828.84,3.447,3.447,0,0,1,.692.081,2.543,2.543,0,0,1,1.2,4.237.833.833,0,0,0,.016,1.334q.532.534,1.066,1.066A.842.842,0,0,0,6.9,21.4a2.482,2.482,0,0,1,1.671-.708A2.539,2.539,0,0,1,11.2,23.239a.819.819,0,0,0,.9.9q.821,0,1.642,0a.82.82,0,0,0,.9-.874A2.553,2.553,0,0,1,19,21.449a.817.817,0,0,0,1.257-.009q.585-.576,1.162-1.16A.827.827,0,0,0,21.437,19a2.552,2.552,0,0,1,1.827-4.346.816.816,0,0,0,.864-.883q0-.848,0-1.7a.811.811,0,0,0-.851-.869,2.457,2.457,0,0,1-2.383-1.576,2.443,2.443,0,0,1,.551-2.779.822.822,0,0,0-.012-1.259c-.365-.371-.736-.737-1.1-1.1a.842.842,0,0,0-1.372-.03,2.511,2.511,0,0,1-1.7.707,2.547,2.547,0,0,1-2.607-2.52.825.825,0,0,0-.938-.918c-.556,0-1.113,0-1.669,0a.813.813,0,0,0-.843.825,3.494,3.494,0,0,1-.082.692A2.539,2.539,0,0,1,6.906,4.464,1.32,1.32,0,0,0,6.2,4.069",
    transform: "translate(0 0)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M32.587,38.616a6.032,6.032,0,1,1,6.064,6.046,6.039,6.039,0,0,1-6.064-6.046m10.34.026a4.308,4.308,0,1,0-4.281,4.3,4.314,4.314,0,0,0,4.281-4.3",
    transform: "translate(-25.691 -25.7)",
    fill: "#707070"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "static/media/icon_settings.2c18cb324c2f16946202560c6063651c.svg";
export { ForwardRef as ReactComponent };